import React from 'react';
import Slider from 'react-slick'; 
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css'; 

const SlickSlider = () => {
  // Define your settings for the slider
  const settings = {
    dots: true,          // Show dots for navigation
    infinite: true,      // Infinite scroll
    speed: 500,          // Speed of the slide transition
    slidesToShow: 1,     // Show 1 slide at a time
    slidesToScroll: 1,   // Scroll 1 slide at a time
    autoplay: true,      // Enable autoplay
    autoplaySpeed: 2000,
  };

  return (
    <div className='section-about myslider-section'>
    <div className=''>
      <Slider {...settings}> 
        <div className='slider-img'>
          <img src="img/Slider/Slider1.jpg" alt="Slider 1" />
        </div>
        <div className='slider-img'>
          <img src="img/Slider/Slider2.jpg" alt="Slider 2" />
        </div>
        <div className='slider-img'>
          <img src="img/Slider/Slider3.jpg" alt="Slider 3" />
        </div>
        <div className='slider-img'>
          <img src="img/Slider/Slider4.jpg" alt="Slider 4" />
        </div>
        <div className='slider-img'>
          <img src="img/Slider/Slider6.jpg" alt="Slider 6" />
        </div>
        <div className='slider-img'>
          <img src="img\Slider\Slider7.jpg" alt="Slider 7" />
        </div>
      </Slider>
    </div>
    </div>
  );
};

export default SlickSlider;
